// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--t0Dl6","content":"card-module--content--ch0UJ","footer":"card-module--footer--1oxSD"};